import { DateInput } from "@msuite/ui/date-input";
import { NumberInput, Textarea } from "@msuite/ui/form";
import { useTranslation } from "@msuite/ui/localization";
import { getPartnerAgreementTypeTranslationKey } from "@msuite/utils/partnerships";
import type { PatchPartnershipNumericAgreementSchema } from "@msuite/utils/schemas";
import type { Enums } from "@msuite/utils/types";
import React from "react";
import { useFormContext } from "react-hook-form";
import { UnitPicker } from "@/components/pickers/unit-picker";
import { useMentionOptions } from "@/hooks/use-mention-options";

/** Props Interface */
interface PartnerNumericAgreementFormProps {
	type: Enums<"organizationPartnershipAgreementType">;
	staticUnit: Enums<"unit"> | "days";
}

export function PartnerNumericAgreementForm({
	type,
	staticUnit,
}: PartnerNumericAgreementFormProps) {
	/** Hooks */
	const { t } = useTranslation();
	const methods = useFormContext<PatchPartnershipNumericAgreementSchema>();
	const mentionOptions = useMentionOptions();

	/** Render */
	return (
		<React.Fragment>
			<DateInput
				control={methods.control}
				name="startDate"
				label={t("partners.valid_from")}
				isRequired
			/>
			<NumberInput
				control={methods.control}
				name="value"
				label={t(getPartnerAgreementTypeTranslationKey(type))}
				placeholder={t("general.enter_value")}
				isRequired
				variant="currency"
				step={0.01}
			/>
			{staticUnit === "days" && (
				<UnitPicker options={["work-days", "calendar-days", "business-days"]} />
			)}
			<Textarea
				label={t("notes.note")}
				name="note"
				control={methods.control}
				placeholder={t("notes.add_note")}
				isRequired={false}
				disableFormatting
				{...mentionOptions}
			/>
		</React.Fragment>
	);
}
